import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class WidgetErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`Widget Error (${this.props.widgetName}):`, error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { widgetName = 'Widget' } = this.props;
      
      return (
        <div className="bg-white p-6 rounded-lg border border-red-200 shadow-sm">
          <div className="flex items-center gap-3 mb-3">
            <AlertTriangle className="text-red-500" size={24} />
            <h3 className="text-lg font-semibold text-gray-800">
              {widgetName} Error
            </h3>
          </div>
          
          <p className="text-gray-600 mb-4">
            This widget encountered an error and couldn't load properly.
          </p>
          
          <button
            onClick={this.handleRetry}
            className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition-colors"
          >
            <RefreshCw size={16} />
            Retry
          </button>
          
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details className="mt-4 p-3 bg-gray-50 rounded border border-gray-200">
              <summary className="cursor-pointer text-sm font-medium">Error Details</summary>
              <pre className="mt-2 text-xs overflow-auto max-h-32">
                {this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default WidgetErrorBoundary;
